<template>
<div>
  <div class="contenPaperBox">
    <div class="userWrapper">
      <div class="avatarUrl">
        <img :src="papers.avatarUrl!=null&&papers.avatarUrl!=''?papers.avatarUrl:globalUrl + 'images/basicprofile.png'" class="avatarUrlPic" />
      </div>
      <div class="itemBox">
        <div class="nickName">{{papers.nikeName!=null&&papers.nikeName!=''?papers.nikeName:'券粉'}}</div>
        <div class="timeWrapper">{{papers.createtime}} </div>
      </div>
      <!--div class="share_btn_wrapper">
        <div class='share_btn'  @click="menuShow">
          <span class='circle'></span>
          <span class='circle'></span>
          <span class='circle'></span>
        </div>
        <div class="deleteWrapper" v-if="menuOpen">
          <div class='triangle_out'>
            <div class='triangle_in'></div>
          </div>
          <div class="deleteContentWrapper">
            <div class='deleteBtnWrapper'>
              <span class="deleteFunction">评论</span>
            </div>
            <div class='deleteBtnWrapper'>
              <span class="deleteFunction">删除</span>
            </div>
            <div class='deleteBtnWrapper' @click="menuShow">
              <span>取消</span>
            </div>
          </div>
        </div>
      </div-->
    </div>
    <div class="cotent">{{papers.content}}</div>
    <div v-for="(pics,index) in papers.pics" class="picItem">
      <img :src="globalUrl+pics" class="pic" @click="picView(index)" />
    </div>
    <paperWelfare :paperid="paperid"></paperWelfare>
    <paperCoupons :paperid="paperid"></paperCoupons>
    <doGood :thumbCount = "papers.thumbCount * 1" :isDoGood = "papers.thumbOpenid" :paperID = "papers.paperid" :openID="this.openID" :getThumbs="getThumbs" @updataThumbOpenid="updataThumbOpenid" v-if="papers.paperid"></doGood>
    <doGoodNum  :getThumbs="getThumbs" :goodThumbs='goodThumbs' v-if="papers.thumbCount>0&&papers.paperid"></doGoodNum>
  </div>
  <!-- Root element of PhotoSwipe. Must have class pswp. -->
  <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

    <!-- Background of PhotoSwipe.
             It's a separate element, as animating opacity is faster than rgba(). -->
    <div class="pswp__bg"></div>

    <!-- Slides wrapper with overflow:hidden. -->
    <div class="pswp__scroll-wrap">

      <!-- Container that holds slides. PhotoSwipe keeps only 3 slides in DOM to save memory. -->
      <div class="pswp__container">
        <!-- don't modify these 3 pswp__item elements, data is added later on -->
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>

      <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
      <div class="pswp__ui pswp__ui--hidden">

        <div class="pswp__top-bar">

          <!--  Controls are self-explanatory. Order can be changed. -->

          <div class="pswp__counter"></div>

          <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

          <button class="pswp__button pswp__button--share" title="Share"></button>

          <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

          <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

          <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
          <!-- element will get class pswp__preloader--active when preloader is running -->
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
          <div class="pswp__share-tooltip"></div>
        </div>

        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
                </button>

        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
                </button>

        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>

      </div>

    </div>

  </div>
  <discuss  :getDiscuss="getDiscuss" :discuss="discuss"></discuss>
  <message :paperID = "papers.paperid" :openID = "openID" :getDiscuss = "getDiscuss"></message>
</div>
</template>
<script type = "text/ecamscript-6">
import {
  getDateDiff,
  config
} from '../../common/js/common.js'
import photoswipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import PaperWelfare from '@/components/quan/paperWelfare'
import PaperCoupons from '@/components/quan/paperCoupons'
import DoGood from '@/components/quan/doGood'
import DoGoodNum from '@/components/quan/doGoodNum'
import Discuss from '@/components/quan/discuss'
import Message from '@/components/quan/message'
export default {
  name: "paper",
  data() {
    return {
      page: 1,
      pageSize: 2,
      paperid: this.$route.params.paperid,
      thumbOpenid:this.$route.query.paperthumbid,
      globalUrl: config.gobalUrl,
      papers: [],
      menuOpen:false,
      openID:JSON.parse(sessionStorage.userInfo).openId,
      goodThumbs:{},
      discuss:[]
    }
  },
  created() {
    this.login()
  },
  methods: {
    login() {

      this.url = "api/getPaperInfo.php?page=" + this.page + "&pageSize=" + this.pageSize + "&paperid=" + this.paperid+"&thumbOpenid="+this.openID
      console.log(this.url)
      this.$ajax.autoService
        .login(this.url)
        .then((res) => {
          this.papers = this.papers.concat(res.data.map(function(item) {
            item.createtime = getDateDiff(new Date(item.createtime.replace(/-/g, '/')));
            if (item.picUrls && item.picUrls != '') {
              item.pics = item.picUrls.split(',')
            }
            item.menuOpen = false
            return item
          }));
          this.papers = this.papers[0]
          console.log(this.papers)
          this.$nextTick(() => {
            this.REQUIRE = true;
            this.loading = false;
          });
        }, (res) => {
          console.log("error")
          this.REQUIRE = true;
        })
    },
    picView(prama1) {
      var pswpElement = document.querySelectorAll('.pswp')[0];
      var picIndex = 0,
        items = [],
        item;
      for (var i = 0; i < this.papers.pics.length; i++) {
        var img = new Image();
        var picSrc, picWidth, picHeight;
        picSrc = this.globalUrl + this.papers.pics[i];
        img.src = picSrc;
        picWidth = img.width;
        picHeight = img.height;
        item = {
          src: picSrc,
          w: picWidth,
          h: picHeight
        }
        items.push(item)
      }

      var options = {
        index: prama1,
      };


      var gallery = new photoswipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    },
    menuShow(){
      this.menuOpen=!this.menuOpen
    },
    getThumbs(doType){
      //console.log(this.goodID)
      this.$ajax.autoService.
      login("api/getThumbs.php?paperid="+this.papers.paperid).then((res)=>{
        this.goodThumbs = res.data
        console.log(this.goodThumbs)
        this.papers.thumbCount =this.papers.thumbCount*1+doType*1
      })
    },
    updataThumbOpenid(val,num){//触发子组建改变点赞
      this.papers.thumbOpenid = val;
      this.papers.thumbCount = this.papers.thumbCount*1+num
      let goodThumbsTemp = [];
      if(num<0){
        for (let i = 0; i < this.goodThumbs.length; i++) {
            if (this.goodThumbs[i].thumbopenid != this.openID) {
            goodThumbsTemp.push(this.goodThumbs[i])
            }
          }
          this.goodThumbs = goodThumbsTemp
      }
    },
    getDiscuss(doType,page,pageSize) {
      this.$ajax.autoService.
      login("api/getDiscuss.php?paperid="+this.paperid+"&page="+page+"&pageSize="+pageSize).then((res)=>{
        console.log(res.data)
        this.discuss = res.data.map(function (item) {
            item.menuShow = false
            return item
          })
        this.papers.discussCount =this.papers.discussCount*1+doType*1
      })
    }
  },
  components: {
    'paperWelfare': PaperWelfare,
    'paperCoupons': PaperCoupons,
    'doGood': DoGood,
    'doGoodNum': DoGoodNum,
    'discuss': Discuss,
    'message': Message
  }
}
</script>
<style  lang="stylus">
  .contenPaperBox
    width: 100%
    padding: 20px 30px
    background: #fff
    box-sizing: border-box
    .userWrapper
      display: flex
      .avatarUrl
        flex: 0 0 80px
        .avatarUrlPic
          width: 80px
          height: 80px
          display: block
          border-radius: 50%
    .itemBox
      flex: 1
      padding-left: 20px
      box-sizing: border-box
      .nickName
        font-size: 28px
        color: #333
      .timeWrapper
        font-size: 24px
        color: #999
    .share_btn_wrapper
      flex: 0 0 50px
      position: relative
      .share_btn
        width: 50px
        height: 80px
        line-height: 80px
        font-size:0px
        .circle
          display: inline-block
          width: 6px
          height: 6px
          border-radius: 3px
          background: #aaa
          vertical-align: middle
          margin:0 3px
      .deleteWrapper
        width: 198px
        position: absolute
        right: -20px
        top:70px;
        box-sizing: border-box
        box-shadow: 0 0 5px #eee
        border: 1px solid #e5e5e5
        /*px*/
        background: #fff
        z-index: 10
        .triangle_out
          width: 36px
          height: 14px
          position: absolute
          top: -13px
          right: 35px
          overflow: hidden
          z-index: 10
        .triangle_in
          width: 20px
          height: 20px
          background: #fff
          transform: rotate(45deg)
          position: absolute
          left: 8px
          top: 6px
          box-shadow: 0 0 5px #eee
          border: 1px solid #e5e5e5
        .deleteBtnWrapper
          font-size: 28px
          color: #666
          text-align: center
          line-height: 80px
          border-bottom: 1px solid #e5e5e5
          /*px*/
    .cotent
      font-size: 34px
      color: #333
      line-height: 50px
      margin-top: 30px
    .picItem
      margin-top: 20px
      .pic
        max-width: 100%
</style>



// WEBPACK FOOTER //
// src/components/quan/paper.vue